<template>
    <div class="bax-drug-patient-list">
        <div class="bax-drug-patient-summary d-md-flex align-items-center" v-if="!isTPN()">
            <div v-if="patient.firstName.length + patient.lastName.length !== 0" class="bax-patient-name">
                Patient Name
                <h3>{{(patient.firstName.length + patient.lastName.length) == 0 ? '--' : patient.firstName + ' ' + patient.lastName}}</h3>
            </div>
            <div v-else class="bax-patient-name">
                <h3>No patient name</h3>
            </div>
            <div v-if="patient.firstName.length + patient.lastName.length !== 0" class="bax-patient-summary ml-auto mt-3 mt-md-0">
                <ul class="text-md-right">
                    <li>
                        Patient ID (MRN): <strong>{{ generalPatientID }}</strong>
                    </li>
                    <li>
                        Date of Birth : <strong>{{ patient.dateOfBirth ? patient.dateOfBirth : '--' }}</strong>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bax-drug-patient-summary d-md-flex align-items-center" v-else>
            <div class="bax-patient-name">
                <h2>Products Ordered</h2>
            </div>
        </div>
        <div class="bax-patient-drug-list" v-if="open === true">
            <ul>
                <slot />
            </ul>
        </div>
    </div>
</template>

<script>

import tpnMixin from '@/mixins/tpnMixin';

    export default {
    name: 'OrderSummaryPatientList',
        mixins: [tpnMixin],
    props: {
        patient: {
            type: Object,
        },
    },
    data() {
        return {
            open: true,
        };
    },
    mounted() {
    },
    computed: {
        generalPatientID() {
            if (this.patient.patientId !== '') {
                if (this.patient.patientId.search(/\*\d+\*/) === -1) {
                    return this.patient.patientId;
                }

                return '';
            }

            return '';
        },
    },
    methods: {
        openDetails() {
            this.open = true;
            this.$emit('item-open');
        },
        closeDetails() {
            this.open = false;
            this.$emit('item-close');
        },
        toggleBox() {
            if (this.open === true) {
                this.closeDetails();
            } else {
                this.openDetails();
            }
        },
    },
};
</script>

<style scoped>
.bax-drug-patient-list {
    cursor: pointer;
}
</style>
